// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-bot {
  background-color: #F2F2F2;
  font-size: 14px;
  letter-spacing: 0.5px;
  font-weight: 400;
  font-family: "Mulish", sans-serif;
  border-radius: 10px 10px 10px 0;
  word-wrap: break-word;
  padding: 9px 13px;
  color: #000000;
  margin-top: 5px;
  line-height: 20px;
  max-width: 80%;
  min-height: 17px;
  min-width: 38px;
  margin-left: 5%;
  margin-bottom: 2%;
}

.chat-user {
  background-color: #26C6DA;
  font-size: 14px;
  letter-spacing: 0.5px;
  font-weight: 400;
  font-family: "Mulish", sans-serif;
  border-radius: 10px 10px 0 10px;
  word-wrap: break-word;
  padding: 9px 13px;
  color: #ffffff;
  width: auto;
  max-width: 70%;
  line-height: 20px;
  margin-left: 25%;
  margin-top: 5%;
}

p-button {
  margin-right: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/main/quick-panel/chat-message/chat-message.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,iCAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,iCAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACI,iBAAA;AACJ","sourcesContent":[".chat-bot {\r\n  background-color: #F2F2F2;\r\n  font-size: 14px;\r\n  letter-spacing: 0.5px;\r\n  font-weight: 400;\r\n  font-family: 'Mulish', sans-serif;\r\n  border-radius: 10px 10px 10px 0;\r\n  word-wrap: break-word;\r\n  padding: 9px 13px;\r\n  color: #000000;\r\n  margin-top: 5px;\r\n  line-height: 20px;\r\n  max-width: 80%;\r\n  min-height: 17px;\r\n  min-width: 38px;\r\n  margin-left: 5%;\r\n  margin-bottom: 2%;\r\n}\r\n\r\n.chat-user {\r\n  background-color: #26C6DA;\r\n  font-size: 14px;\r\n  letter-spacing: 0.5px;\r\n  font-weight: 400;\r\n  font-family: 'Mulish', sans-serif;\r\n  border-radius: 10px 10px 0 10px;\r\n  word-wrap: break-word;\r\n  padding: 9px 13px;\r\n  color: #ffffff;\r\n  width: auto;\r\n  max-width: 70%;\r\n  line-height: 20px;\r\n  margin-left: 25%;\r\n  margin-top: 5%;\r\n}\r\n\r\np-button {\r\n    margin-right: 2px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
